import CONSTANTS from "@/constants.js";
import Vue from "vue";
import axios from "axios";
import router from "@/router";
import { cloneDeep } from "lodash";
import constants from "../../../constants";

const AUTH_TOKEN = process.env.VUE_APP_THREEKIT_TOKEN;

const project = {
  namespaced: true,

  state: () => ({
    actualPage: 1,
    color_1: CONSTANTS.DEFAULT.C1,
    color_2: CONSTANTS.DEFAULT.C2,
    color_3: CONSTANTS.DEFAULT.C3,
    projectLogos: [],
    defaultLogoId: null,
    lockerCode: null,
    temporaryNewSchool: {},

    mode: CONSTANTS.PROJECT_MODES.PREVIEW, //'create', 'edit', 'preview'
    rep: {},
    typeOfProject: null,

    //2d Decorations
    locationDecorations: [],

    uniformDecorationFillColor: null,
    uniformDecorationOutlineColor: null,
    spiritwearDecorationFillColor: null,
    spiritwearDecorationOutlineColor: null,

    uniformMascot: "TEAM NAME",
    spiritwearMascot: "TEAM NAME",
    spiritwearSubMascot: "ATHLETICS",
    centerDecoration: "", //used for spiritwear center logo

    uniformFont: null,
    spiritwearFont: null,

    uniformCustomGraphic: null,
    spiritwearCustomGraphic: null,

    //UI
    loading: false,
    showSaveIndicator: false,
    exportingToPDF: false,
    showLockerPreviewModalOpen: false,
    designsModalProduct: false,
    paginationActive: true,

    activeProduct: {},
    editableProduct: {},
    temporalProduct: {},
    editableHero: {},
    screenWidth: window.innerWidth,
    globalUniformDecorations: cloneDeep(
      CONSTANTS.PRODUCT_DECORATIONS_STRUCTURE
    ),

    //PLP 2d decoration
    customDecorationTextLoading: true,
    customSpiritwearTextLoading: true,
  }),

  getters: {
    isMobile: (state) => {
      return state.screenWidth <= 1024;
    },

    onePageMode: (_state, getters) => {
      return getters.isMobile || getters.isCreateMode;
    },

    projectHasDealerHeader: (state) => {
      return state.type === "showrooms"; //TODO get value from dealer options maybe?
    },

    projectId(_state, getters, rootState) {
      return getters.isSnapsheet
        ? rootState.snapsheet.snapsheetId
        : rootState.playbook.playbookId;
    },

    projectStatus(_state, getters, rootState) {
      return getters.isSnapsheet
        ? rootState.snapsheet.status
        : rootState.playbook.status;
    },

    projectIsLocked(_, getters) {
      return (
        getters.projectStatus === CONSTANTS.PROJECT_STATUS.CLOSED_STATUS ||
        getters.projectStatus === CONSTANTS.PROJECT_STATUS.ARCHIVED ||
        getters.projectStatus === CONSTANTS.PROJECT_STATUS.COMPLETE
      );
    },

    projectRoute(state, getters, rootState, rootGetters) {
      const typeOfProject = state.typeOfProject + "s";
      if (typeOfProject === "showrooms") {
        if (rootState.showroom.selectedCatalogsProducts?.length === 0) {
          return `/${typeOfProject}/${rootGetters["showroom/dealerCode"]}/`;
        }
        return `/${typeOfProject}/${rootGetters["showroom/dealerCode"]}/catalogue`;
      }
      return `/${typeOfProject}/${rootState.dealer.rhino_code}/${getters.projectId}/`;
    },

    color1(_state, getters, rootState) {
      const currentColor = getters.isPlaybook
        ? rootState.playbook.color_1
        : getters.isSnapsheet
        ? rootState.snapsheet.color_1
        : rootState.showroom.color_1;

      return CONSTANTS.COLORS.find((color) => {
        return color.id === currentColor;
      });
    },

    color2(_state, getters, rootState) {
      const currentColor = getters.isPlaybook
        ? rootState.playbook.color_2
        : getters.isSnapsheet
        ? rootState.snapsheet.color_2
        : rootState.showroom.color_2;

      return CONSTANTS.COLORS.find((color) => {
        return color.id === currentColor;
      });
    },

    color3(_state, getters, rootState) {
      const currentColor = getters.isPlaybook
        ? rootState.playbook.color_3
        : getters.isSnapsheet
        ? rootState.snapsheet.color_3
        : rootState.showroom.color_3;

      return CONSTANTS.COLORS.find((color) => {
        return color.id === currentColor;
      });
    },

    fsgSiteCreatePlaybookUrl() {
      return `${process.env.VUE_APP_FGS_SITE}/my-account/create-catalog`;
    },

    fsgSiteCreateSnapsheetUrl() {
      return `${process.env.VUE_APP_FGS_SITE}/create-snapsheet`;
    },

    getColorById: () => (id) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === id;
      });
    },

    getColorByName: () => (name) => {
      return CONSTANTS.COLORS.find((color) => {
        return (
          color.name?.trim()?.toLowerCase() ===
          (name && name?.trim()?.toLowerCase())
        );
      });
    },
    getColorByStockName: () => (name) => {
      return CONSTANTS.COLORS.find((color) => {
        return (
          color.stock_name?.trim()?.toLowerCase() ===
          (name && name?.trim()?.toLowerCase())
        );
      });
    },

    getCustomerPrice:
      (_, __, rootState) =>
      ({ msrp, price }) => {
        const msrpFixed = Number(msrp)?.toFixed(2);
        const customerPrice = (
          msrpFixed * rootState.dealer.dealerMargin
        ).toFixed(2);
        const priceFixed = Number(price)?.toFixed(2);
        //Return MRSP * 2 or a edited price
        const finalPrice = msrpFixed
          ? msrpFixed === priceFixed
            ? customerPrice
            : priceFixed
          : priceFixed;

        return finalPrice;
      },

    getSizeSkuCodeBySizeCode: () => (size) => {
      switch (size?.toUpperCase()) {
        case "OSFA":
          return "01";
        case "XXS":
          return "02";
        case "XS":
          return "03";
        case "S":
          return "04";
        case "M":
          return "05";
        case "L":
          return "06";
        case "XL":
          return "07";
        case "2XL":
          return "08";
        case "3XL":
          return "09";
        case "4XL":
          return "10";
        // case "4XL":
        //   return "11";
        case "YTH":
          return "13";
        case "S/M":
          return "14";
        case "L/XL":
          return "15";
        case "2XL/3XL":
          return "16";
        case "XXS/XS":
          return "26";

        default:
          return "01";
      }
    },

    isEditMode: (state) => {
      return state.mode === CONSTANTS.PROJECT_MODES.EDIT;
    },

    isCreateMode: (state) => {
      return state.mode === CONSTANTS.PROJECT_MODES.CREATE;
    },

    isPreviewMode: (state) => {
      return state.mode === CONSTANTS.PROJECT_MODES.PREVIEW;
    },

    isPlaybook: (state) => {
      return state.typeOfProject === "catalog";
    },

    isSnapsheet: (state) => {
      return state.typeOfProject === "snapsheet";
    },

    isShowroom: (state) => {
      return state.typeOfProject === "showroom";
    },

    projectTitle: (_, getters, rootState) => {
      return getters.isPlaybook
        ? rootState.playbook.title
        : getters.isSnapsheet
        ? rootState.snapsheet.title
        : "";
    },

    projectTeamName: (_, getters, rootState) => {
      return getters.isPlaybook
        ? rootState.playbook.teamName
        : getters.isSnapsheet
        ? rootState.snapsheet.teamName || "Team Name"
        : rootState.showroom.mascot?.trim().length > 0
        ? rootState.showroom.mascot
        : rootState.showroom.selectedInstitutionName;
    },

    projectRep(_, getters, rootState, rootGetters) {
      return getters.isPlaybook
        ? rootGetters["dealer/getRepById"](rootState.playbook.repId)
        : getters.isSnapsheet
        ? rootGetters["dealer/getRepById"](rootState.snapsheet.repId)
        : "";
    },

    projectColors(_, getters, rootState, rootGetters) {
      if (getters.isPlaybook) {
        return [
          {
            key: "color_1",
            label: "main",
            color: rootGetters["playbook/playbookColors"][0],
          },
          {
            key: "color_2",
            label: "second",
            color: rootGetters["playbook/playbookColors"][1],
          },
          {
            key: "color_3",
            label: "third",
            color: rootGetters["playbook/playbookColors"][2],
          },
        ];
      } else if (getters.isSnapsheet) {
        return [
          {
            key: "color_1",
            label: "main",
            color: getters.getColorById(rootState.snapsheet.color_1),
          },
          {
            key: "color_2",
            label: "second",
            color: getters.getColorById(rootState.snapsheet.color_2),
          },
          {
            key: "color_3",
            label: "third",
            color: getters.getColorById(rootState.snapsheet.color_3),
          },
        ];
      }
      //showroom
      else {
        return [
          {
            key: "color_1",
            label: "main",
            color: rootGetters["showroom/showroomColors"][0],
          },
          {
            key: "color_2",
            label: "second",
            color: rootGetters["showroom/showroomColors"][1],
          },
          {
            key: "color_3",
            label: "third",
            color: rootGetters["showroom/showroomColors"][2],
          },
        ];
      }
    },

    projectProducts(state, getters, rootState, rootGetters) {
      const projectProducts = getters.isSnapsheet
        ? rootState.snapsheet.products
        : rootGetters["playbook/playbookProducts"];

      return [...projectProducts, state.temporalProduct];
    },

    showProjectPrices(_, getters, rootState) {
      return getters.isSnapsheet
        ? rootState.snapsheet.showPrices
        : getters.isPlaybook
        ? rootState.playbook.showPrices
        : true;
    },

    showCoverAndIndex(_, _getters, rootState) {
      return rootState.playbook.showCoverAndIndex;
    },

    uniformFillColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.uniformDecorationFillColor;
      });
    },

    uniformOutlineColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.uniformDecorationOutlineColor;
      });
    },

    uniformMascot: (state) => {
      return state.uniformMascot;
    },

    spiritwearMascot: (state) => {
      return state.spiritwearMascot;
    },

    spiritwearSubMascot: (state) => {
      return state.spiritwearSubMascot;
    },

    spiritwearFillColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.spiritwearDecorationFillColor;
      });
    },

    spiritwearOutlineColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.spiritwearDecorationOutlineColor;
      });
    },

    spiritwearFont: (state) => {
      return state.spiritwearFont;
    },

    uniformFont: (state) => {
      return state.uniformFont;
    },

    uniformCustomGraphic: (state) => {
      return state.uniformCustomGraphic;
    },

    spiritwearCustomGraphic: (state) => {
      return state.spiritwearCustomGraphic;
    },

    projectColorDependingOnProjectType: (_state, getters) => {
      //Showrooms/Playbooks = All colors
      //Snapsheets = Some colors
      return getters.isSnapsheet
        ? CONSTANTS.COLORS.filter((color) => {
            return CONSTANTS.SPANSHEET_COLORS_IDS.some(
              (colorId) => colorId == color.id
            );
          })
        : CONSTANTS.COLORS;
    },

    projectSidebarCatalogs(_state, getters, rootState) {
      return getters.isPlaybook
        ? []
        : getters.isSnapsheet
        ? rootState.snapsheet.snapheetsCollections
        : [];
    },

    defaultLogo(state, getters, _rootState, rootGetters) {
      if (getters.isShowroom) {
        const logo = rootGetters["uploadLogos/editableLogo"];
        return rootGetters["uploadLogos/normalizeLogoData"](logo);
      } else {
        const logo = state.projectLogos?.find(
          (logo) => logo?.id === state.defaultLogoId
        );
        return logo && rootGetters["uploadLogos/normalizeLogoData"](logo);
      }
    },

    hexToRGB: () => (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },

    textStampFillColor: (_, getters, rootState) => (hex) => {
      return getters.hexToRGB(
        hex
          ? hex
          : getters.isPlaybook
          ? getters.getColorById(rootState.playbook.color_2)?.hex
          : "#FFFFFF"
      );
    },

    textStampOutlineColor: (_, getters, rootState) => (hex) => {
      return getters.hexToRGB(
        hex
          ? hex
          : getters.isPlaybook
          ? getters.getColorById(rootState.playbook.color_3)?.hex
          : "#000000"
      );
    },

    textStampURL:
      (_, getters) =>
      (textValue, fillColor, outlineColor, font = constants.FONTS[0].file) => {
        return `https://rendercdn.builder.foundersport.com/api/builder/custom-text?json={%22text%22:%22${textValue}%22,%22size%22:800,%22font%22:%22${font?.toLowerCase()}%22,%22strokes%22:[{%22color%22:%22rgb(${
          getters.textStampOutlineColor(outlineColor)?.r
        },${getters.textStampOutlineColor(outlineColor)?.g},${
          getters.textStampOutlineColor(outlineColor)?.b
        })%22}],%22color%22:%22rgb(${
          getters.textStampFillColor(fillColor)?.r
        },${getters.textStampFillColor(fillColor)?.g},${
          getters.textStampFillColor(fillColor)?.b
        })%22}`;
      },

    getLogoById: (state) => (logoId) => {
      return state.projectLogos.find((logo) => {
        return logo?.id == logoId;
      });
    },

    isTemporalProductEmpty: (state) => {
      return !state.temporalProduct.alias;
    },

    showSnapsheetUniformProductModal: (state, getters) => {
      if (getters.isTemporalProductEmpty) return false;

      return (
        getters.isSnapsheet &&
        getters["productIsUniform"](state.temporalProduct) &&
        !getters["snapsheetHaveUniforms"]
      );
    },

    snapsheetHaveUniforms: (_state, getters, rootState) => {
      return rootState.snapsheet.products.some((pr) =>
        getters["productIsUniform"](pr)
      );
    },

    productIsUniform: () => (product) => product?.category === "Jerseys",

    activeProductIsUniform: (state, getters) =>
      getters["productIsUniform"](state.activeProduct),

    mapFlashColorName: () => (colorName) => {
      switch (colorName) {
        case "texas": {
          return "texas%2dorange";
        }
        case "columbia": {
          return "columbia%2dblue";
        }
        case "royal": {
          return "royal%2dblue";
        }
        default: {
          return colorName;
        }
      }
    },

    //product
    getProductTextStamp:
      (_, getters) => (product, textStampKey, defaultValue) => {
        return {
          value:
            product.decorations?.front?.[textStampKey]?.value ||
            defaultValue ||
            "",
          fill:
            product.decorations?.front?.[textStampKey]?.fill ||
            getters.projectColors[1]?.color?.id,
          outline:
            product.decorations?.front?.[textStampKey]?.outline ||
            getters.projectColors[2]?.color?.id,
          font: product.decorations?.front?.[textStampKey]?.font,
        };
      },

    getPrecoloredDesignURL:
      () => (color, colorKey, designSlug, isChromagear) => {
        const colorName = isChromagear
          ? color.chromagear_name
          : color.stock_name;
        return `${
          CONSTANTS.S3_BASE_URL
        }assets/${designSlug}_${colorKey}_${colorName.toLowerCase()}.png`;
      },

    getPrecoloredShadowURL: () => (precoloredDesignShadow) => {
      return `${CONSTANTS.S3_BASE_URL}assets/${precoloredDesignShadow}`;
    },

    is3DAvailable: (state) => {
      //check if the 3d is available
      return !state.activeProduct?.is3DAvailable;
    },
  },

  actions: {
    async initWindowThreekitPlayer() {
      if (!window.threekitPlayer) {
        let threeKitScript = document.createElement("script");
        const url = `${process.env.VUE_APP_THREEKIT_ENDPOINT}/app/js/threekit-player.js`;
        threeKitScript.setAttribute("src", url);
        document.head.appendChild(threeKitScript);
        // setTimeout(() => {
        //   dispatch("init2DDecorationsApi");
        // }, 5000);
      }
    },

    async initProject({ rootState, state, getters, dispatch, commit }) {
      try {
        if (!getters.projectId && !getters.isShowroom) {
          dispatch("triggerStartLoading", null, { root: true });

          await dispatch("threekit/initThreekitColors", null, { root: true });

          //Only get dealer info in edit or preview mode
          !getters.isCreateMode &&
            (await dispatch("dealer/getDealerInProject", null, { root: true }));

          //Delete the passcode from the URL
          let query = Object.assign({}, router.currentRoute.query);
          if (query.passcode) {
            delete query.passcode;
            router.replace({ query });
          }

          getters.isPlaybook
            ? await dispatch("playbook/initPlaybook", null, { root: true })
            : await dispatch("snapsheet/initSnapsheet", null, { root: true });
          dispatch("triggerEndLoading", null, { root: true });

          // //Get the threekit info for each product
          // const products = getters.isPlaybook ? rootState.playbook.products : rootState.snapsheet.products
          // await Promise.all(products.map(async (product) => {
          //   product?.id && await dispatch('threekit/initProductCache', { styleName: product.alias, designName: product.design_name }, { root: true })
          // }))

          // //Get 2D Decorations
          // await dispatch('threekit/init2DDecorationsPlayer', null, { root: true });

          // // Getting a standard snapshot with all 3 content types:
          // for (const decorationObject of rootState.threekit.decorationExamples) {
          //   // console.log('222');
          //   const deco = await dispatch('threekit/getLocationSnapshot', { locationName: 'Center Right', configuration: decorationObject }, { root: true })
          //   console.log('deco', deco);
          //   await dispatch('threekit/save2DDecoration', deco, { root: true })

          // }
          // console.log('decorations', rootState.threekit.decorations);

          //Set the project logos
          const logos = getters.isPlaybook
            ? rootState.playbook.logos
            : rootState.snapsheet.logos;
          const defaultLogoId = getters.isPlaybook
            ? rootState.playbook.defaultLogoId
            : rootState.snapsheet.defaultLogoId;

          await dispatch("setProjectLogos", logos);
          await dispatch("setDefaultLogo", defaultLogoId);

          //Update Decorations Graphics
          if (logos?.length) {
            const mainLogo = getters["getLogoById"](state.defaultLogoId);
            commit("SET_UNIFORM_CUSTOM_GRAPHIC", mainLogo);
            commit("SET_SPIRITWEAR_CUSTOM_GRAPHIC", mainLogo);
          }

          //Get the locker
          await dispatch("lockerModule/getLockerByCode", state["lockerCode"], {
            root: true,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async getProject({ rootState, state, getters, dispatch }) {
      try {
        await dispatch("threekit/initThreekitColors", null, { root: true });

        getters.isPlaybook
          ? await dispatch("playbook/getPlaybook", null, { root: true })
          : await dispatch("snapsheet/getSnapsheet", null, { root: true });

        //Set the project logos
        const logos = getters.isPlaybook
          ? rootState.playbook.logos
          : rootState.snapsheet.logos;
        const defaultLogoId = getters.isPlaybook
          ? rootState.playbook.defaultLogoId
          : rootState.snapsheet.defaultLogoId;
        dispatch("setProjectLogos", logos);
        dispatch("setDefaultLogo", defaultLogoId);

        //Get the locker
        await dispatch("lockerModule/getLockerByCode", state["lockerCode"], {
          root: true,
        });
      } catch (error) {
        console.log(error);
      }
    },

    resetProject({ getters, dispatch }) {
      getters.isPlaybook
        ? dispatch("playbook/resetPlaybook", null, { root: true })
        : dispatch("snapsheet/resetSnapsheet", null, { root: true });
    },

    async updateProjectStatus({ getters, state, rootState }, status) {
      if (!getters.isShowroom) {
        try {
          const projectId = getters.projectId;
          const typeOfProject = state.typeOfProject;
          const url = rootState.settings.endpoint + `api/v2/projects/update`;

          let params = {
            project_type: typeOfProject,
            project_id: projectId,
            status,
          };

          await axios.put(url, params);
        } catch (error) {
          console.log(error);
        }
      }
    },

    async publishProject({ rootState, state, getters, dispatch }) {
      try {
        dispatch("triggerStartLoading", null, { root: true });

        //Clean pop-up to prevent the draft projects
        // window.top.onbeforeunload = null
        window.onbeforeunload = null;

        getters.isSnapsheet
          ? await dispatch(
              "snapsheet/updateSnapsheetStatus",
              CONSTANTS.PROJECT_STATUS.PUBLISHED,
              { root: true }
            )
          : await dispatch(
              "playbook/updatePlaybook",
              {
                dbKey: "status",
                field: "status",
                value: CONSTANTS.PROJECT_STATUS.PUBLISHED,
              },
              { root: true }
            );

        //If there is a temporary school, we need to send it to create a School entry in the Queue DB
        if (Object.keys(state.temporaryNewSchool).length > 0) {
          await dispatch("createSchoolInQueue");
        } else if (getters.isPlaybook && !rootState.playbook.schoolCode) {
          //Else, create a Team Travel
          await dispatch("createTeamTravelInQueue");
        }
        await dispatch("setEditMode");

        //Update the actual page. There is a bug where if the page was even, the paginaton will be broken
        dispatch("setPage", state.actualPage);
        dispatch("redirectToProjectPage");
      } catch (error) {
        console.log(error);
        throw new Error("error publishing the project");
      } finally {
        dispatch("triggerEndLoading", null, { root: true });
      }
    },

    async updateShowPrices({ getters, dispatch }, showPrices) {
      getters.isSnapsheet
        ? await dispatch("snapsheet/updateShowPrices", showPrices, {
            root: true,
          })
        : await dispatch("playbook/updateShowPrices", showPrices, {
            root: true,
          });
    },

    // --Logos--

    async addProjectLogo({ state, dispatch, commit }, { logo }) {
      console.log("addProjectLogo", logo);
      try {
        if (logo?.originalLogoId) {
          //Check if the original logo was the Default Logo
          if (
            state.defaultLogoId &&
            state.defaultLogoId === logo?.originalLogoId
          ) {
            //update default logo
            await dispatch("setNewDefautlLogo", logo?.id);
          }

          //Remove the original logo
          await dispatch("removeProjectLogo", logo?.originalLogoId);
        }

        const logoIndex = state.projectLogos.findIndex(
          (projectLogo) => projectLogo?.id == logo?.id
        );

        logoIndex >= 0
          ? commit("UPDATE_PROJECT_LOGO", { logoIndex, logo })
          : commit("ADD_PROJECT_LOGO", logo);
      } catch (error) {
        console.log(error);
      }
    },

    setProjectLogos({ commit }, logos) {
      commit("SET_PROJECT_LOGOS", logos);
    },

    setDefaultLogo({ commit }, logoId) {
      commit("SET_DEFAULT_LOGO", logoId);
    },

    setDefaultDecorationFonts({ commit, rootGetters }) {
      const fullBlock = rootGetters["threekit/fullBlockFont"];
      commit("SET_SPIRITWEAR_FONT", fullBlock);
      commit("SET_UNIFORM_FONT", fullBlock);
    },

    async updateCustomGraphic({ commit, rootState }, payload) {
      const url =
        rootState.settings.endpoint + "/api/logos/" + payload.graphic.id;

      const params = {
        create_asset: true,
        contents: payload.graphic.content,
      };

      const { data } = await axios.put(url, params, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      });

      commit(`SET_${payload.type.toUpperCase()}_CUSTOM_GRAPHIC`, data);
    },

    clearSpiritwearlLogo({ commit }) {
      commit("CLEAR_SPIRITWEAR_LOGO");
      commit("threekit/SET_SPIRITWEAR_THUMBNAIL", null, { root: true }); //move to project
    },

    clearUniformLogo({ dispatch, commit }) {
      commit("CLEAR_UNIFORM_LOGO");
      commit("threekit/SET_UNIFORM_THUMBNAIL", null, { root: true }); //move to project
      dispatch("showroom/getDecorationsForSelectedCatalogLayouts", null, {
        root: true,
      });
    },

    async uploadProjectLogo(
      { rootState, state, getters, dispatch },
      { logo, typesOfLogo }
    ) {
      try {
        const projectId = getters.projectId;
        const typeOfProject = state.typeOfProject;
        const url = rootState.settings.endpoint + `api/logos/${logo.id}`;

        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        let params = {
          project_type: typeOfProject,
          project_id: projectId,
          type: typesOfLogo,
        };

        await axios.put(url, params, settings);
        await dispatch("addProjectLogo", { logo, typesOfLogo });
        //If the logo is the only one in the project, set it as the default logo
        if (
          state.projectLogos.length === 1 &&
          rootState.uploadLogos.applyMode === "project"
        ) {
          await dispatch("setNewDefautlLogo", logo.id);
        }
      } catch (error) {
        throw new Error("error saving the project logo");
      } finally {
        //Reset the apply mode
        dispatch("uploadLogos/setApplyMode", "project", { root: true });
      }
    },

    async editProjectLogo({ getters, dispatch }, logo) {
      try {
        // dispatch('triggerStartLoading', null, { root: true })
        if (getters.isSnapsheet) {
          await dispatch("snapsheet/updateSnapsheetLogo", logo, { root: true });
        }
      } catch (error) {
        throw new Error("error saving the project logo");
      } finally {
        //reset the logos modal action
        dispatch("uploadLogos/setAction", "upload", { root: true });
        //add if necessary
        await dispatch("addProjectLogo", { logo });
      }
    },

    async updateDefaultLogo({ rootState, state, getters, dispatch }, logoId) {
      try {
        //Todo call to the api

        const projectId = getters.projectId;
        const typeOfProject = state.typeOfProject;
        const url = rootState.settings.endpoint + `api/v2/projects/update`;

        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        let params = {
          project_type: typeOfProject,
          project_id: projectId,
          default_logo_id: logoId,
        };

        await axios.put(url, params, settings);

        dispatch("setDefaultLogo", logoId);
      } catch (error) {
        console.log(error);
      }
    },

    async setNewDefautlLogo({ dispatch, getters, commit }, logoId) {
      try {
        await dispatch("updateDefaultLogo", logoId);

        //Update 2D Decorations with this new graphic
        const logo = getters.getLogoById(logoId);
        commit("SET_UNIFORM_CUSTOM_GRAPHIC", logo);
        commit("SET_SPIRITWEAR_CUSTOM_GRAPHIC", logo);
        await dispatch("updateDecorationsForProjectProductsLayouts");
      } catch (error) {
        console.log(error);
      }
    },

    async removeDefaultLogo({ dispatch }) {
      try {
        await dispatch("updateDefaultLogo", null);

        //Update global decorations
        await dispatch("clearSpiritwearlLogo");
        await dispatch("clearUniformLogo");
      } catch (error) {
        throw new Error("error removing the default logo");
      }
    },

    async deleteProjectLogo({ rootState, dispatch }, logoId) {
      try {
        const url =
          rootState.settings.endpoint +
          `api/logos/delete-from-project/${logoId}`;
        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        //Call to the api
        await axios.delete(url, {}, settings);

        //Remove the logo from the snapsheet
        dispatch("removeProjectLogo", logoId);
      } catch (error) {
        throw new Error("error deleting the project logo");
      }
    },

    removeProjectLogo({ state, commit }, logoId) {
      const logoIndex = state.projectLogos.findIndex(
        (logo) => logo.id == logoId
      );
      logoIndex >= 0 && commit("REMOVE_PROJECT_LOGO", logoIndex);
    },

    setPage({ getters, commit }, number) {
      if (getters.onePageMode) {
        commit("SET_PAGE", number);
      } else {
        number % 2 === 0
          ? commit("SET_PAGE", number - 1)
          : commit("SET_PAGE", number);
      }
    },

    setLastPage({ rootState, getters, commit }) {
      let pageNumber = getters.isPlaybook
        ? rootState.playbook.pages.length
        : rootState.snapsheet.pages.length;
      //In one page mode, just set the number.
      // In Two pages mode, if the pageNumber is even, set the prev number. If it's odd, just set it.

      pageNumber = getters.onePageMode
        ? pageNumber
        : pageNumber % 2 === 0
        ? pageNumber - 1
        : pageNumber;
      commit("SET_PAGE", pageNumber);
    },

    setPreviewMode({ commit }) {
      commit("SET_PROJECT_MODE", CONSTANTS.PROJECT_MODES.PREVIEW);
    },

    setEditMode({ commit }) {
      commit("SET_PROJECT_MODE", CONSTANTS.PROJECT_MODES.EDIT);
    },

    setCreateMode({ commit }) {
      commit("SET_PROJECT_MODE", CONSTANTS.PROJECT_MODES.CREATE);
    },

    setProjectRep({ commit }, rep) {
      commit("SET_PROJECT_REP", rep);
    },

    setExportPDFMode({ commit }, status) {
      commit("SET_EXPORT_PDF", status);
    },

    setProjectLockerCode({ commit }, lockerCode) {
      commit("SET_PROJECT_LOCKER_CODE", lockerCode);
    },

    //Products Actions

    async getProductData(_, { styleName }) {
      try {
        const url = `${process.env.VUE_APP_BUILDER_ENDPOINT}/product/${styleName}`;
        const { data } = await axios.get(url);
        return data?.["products"]?.[0];
      } catch (error) {
        console.log(error);
      }
    },

    async getProductDecorationsBundleAssetId({ dispatch }, { styleName }) {
      try {
        const productsData = await dispatch("getProductData", { styleName });
        const bundleId =
          productsData?.["metadata"]?.["decorationsBundleAssetId"];
        return bundleId;
      } catch (error) {
        console.log("error in getProductDecorationsBundleAssetId: ", error);
      }
    },

    async saveNewProduct({ getters, dispatch }) {
      try {
        if (getters.isSnapsheet) {
          await dispatch("snapsheet/saveNewSnapsheetProduct", null, {
            root: true,
          });
        } else {
          dispatch(
            "showToast",
            {
              txt: "Implementation in progress",
              type: "error",
            },
            { root: true }
          );
        }
      } catch (error) {
        throw new Error("error saving the new product");
      }
    },

    async getProductByStyleId({ rootState }, styleId) {
      try {
        const url =
          rootState.settings.endpoint +
          `api/v2/catalog/info/product/${styleId}`;

        const options = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        const { data } = await axios.get(url, options);
        return data;
      } catch (error) {
        console.log(error);
      }
    },

    async getProductSizesPrice({ rootState, rootGetters, state }, styleId) {
      try {
        const url = rootState.settings.endpoint + `api/v2/lockers/msrp`;
        const options = {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            design:
              state.activeProduct.design_name || state.activeProduct.designName,
            style: styleId,
          },
        };

        const isSublimated = rootGetters["threekit/isSublimated3D"];
        //Only send the "color" params for stock products
        if (!isSublimated) {
          options.params["color"] =
            rootGetters["threekit/activeProductPrincipalColors"]?.[0] ||
            state.activeProduct.product_colors?.[0];
        }

        const { data } = await axios.get(url, options);
        //We have to loop over the keys to get the sizes
        //Sometimes the sizes are together, united by a "/"
        const sizesRawKeys = Object.keys(data);
        const sizes = sizesRawKeys.reduce((acc, key) => {
          const sizes = key.split("/");
          return [...acc, ...sizes];
        }, []);

        //Find the sizes, but check the slashes
        const prices = sizes.reduce((acc, sizeKey) => {
          //Find the raw key, with or without the slash
          const rawKey = sizesRawKeys.find((k) => k.includes(sizeKey));
          const price = data[rawKey];
          if (price) {
            return [...acc, { size: sizeKey, price }];
          }
          return acc;
        }, []);

        return prices;
      } catch (error) {
        console.log(error);
      }
    },

    //Active Product

    async goToActiveProductPage(
      { rootState, state, rootGetters, getters, dispatch },
      product
    ) {
      await dispatch("setActiveProduct", { product });

      //Redirect to the active product page

      //Short Id is to load a previous saved configuration
      const short_id = product.short_id;
      const typeOfProject = state.typeOfProject + "s";

      let route;

      if (typeOfProject === "showrooms") {
        route = short_id
          ? `/showrooms/${rootGetters["showroom/dealerCode"]}/product/${product.style_id}?short_id=${short_id}`
          : `/showrooms/${rootGetters["showroom/dealerCode"]}/product/${product.style_id}`;
      } else {
        route = short_id
          ? `/${typeOfProject}/${rootState.dealer.rhino_code}/${getters.projectId}/product/${product.style_id}?short_id=${short_id}`
          : `/${typeOfProject}/${rootState.dealer.rhino_code}/${getters.projectId}/product/${product.style_id}`;
      }
      router.push(route);
    },

    setActiveProduct({ rootState, getters, commit }, { product, layout }) {
      console.log("set active product", product);
      if (!product) {
        commit("SET_ACTIVE_PRODUCT", {});
        return false;
      }
      //Todo -> sublimation properties
      const productToCopy = {
        ...product,
        id: product.id,
        name: product.name,
        productPrice: Number(
          product.customProductPrice || product.productPrice || product.price
        ),
        price: Number(product.price || product.productPrice),
        dealerPrice: product.dealerPrice
          ? Number(product.dealerPrice)
          : Number(product.dealer_price),
        colors: [product.color_1, product.color_2, product.color_3],
        design: product.design,
        decorations: product.decorations
          ? { ...product.decorations }
          : //Down here, we will set the default values for team name and number for Instant Playbook's uniforms products
          getters.isPlaybook && (product.is_sublimable || product.isSublimable)
          ? {
              front: {
                name: { value: rootState.playbook.teamName },
                number: { value: "00" },
              },
              back: {},
              side: {},
            }
          : {
              front: {},
              back: {},
              side: {},
            },
        variant: product.variant || product.variant,
        variants: product.variants,
        layout,
        styleName: product.style_id || product.style_name || product.styleName,
        designName: product.designName,
      };

      //Saved config
      if (product.threekitConfigId) {
        productToCopy["shortId"] = product.threekitConfigId;
      }

      commit("SET_ACTIVE_PRODUCT", cloneDeep(productToCopy));
      // commit('SET_EDITABLE_PRODUCT', cloneDeep(productToCopy))
    },

    resetEditableProduct({ state, commit }) {
      commit("SET_EDITABLE_PRODUCT", cloneDeep(state.activeProduct));
    },

    changeActiveProductLayout({ commit }, layoutId) {
      commit("SET_ACTIVE_PRODUCT_LAYOUT", layoutId);
    },

    changeActiveProductVariant({ commit }, variant) {
      commit("CHANGE_ACTIVE_PRODUCT_VARIANT", variant);
    },

    applyProductDecorationsChanges(
      { commit },
      {
        TYPE_OF_PRODUCT,
        sideKey,
        decorationPropertyName,
        decorationPropertyValue,
      }
    ) {
      //TypeOfProduct -> 'ACTIVE' OR 'EDITABLE'
      commit(`APPLY_PRODUCT_DECORATIONS`, {
        TYPE_OF_PRODUCT,
        sideKey,
        decorationPropertyName,
        decorationPropertyValue,
      });
    },

    async addToLocker(
      { rootState, rootGetters, state, getters, dispatch },
      {
        product,
        layout,
        isPrecolored,
        precoloredDesign,
        precoloredShadow,
        isChromagear,
        designDimension,
        heroDesign,
        builderConfig,
        shortId,
      }
    ) {
      try {
        console.log("builderConfig", builderConfig)
        const isNewLockerProduct = product["lockerProductId"] ? false : true;
        let url = isNewLockerProduct
          ? rootState.settings.endpoint + `/api/v2/lockers/item`
          : rootState.settings.endpoint +
            `/api/v2/lockers/item/${product["lockerProductId"]}`;
        let lockerCode = state.lockerCode;

        //Design prop
        let design = null;

        const designAttr = rootState.threekit.globalConfigurator
          .getDisplayAttributes()
          ?.find((attr) => attr?.name === "Design");
        if (designAttr) {
          const selectedDesignAssetId = designAttr?.value?.assetId;
          const selectedDesign = designAttr.values?.find(
            (design) => design?.assetId === selectedDesignAssetId
          );
          console.log({ selectedDesign });
          design = selectedDesign;
        }

        //Fabric prop
        let fabric = null;

        if (designAttr) {
          const fabricAttr = rootState.threekit.globalConfigurator
            .getDisplayAttributes()
            ?.find((attr) => attr?.name === "Fabric");
          const selectedFabricAssetId = fabricAttr?.value?.assetId;
          const selectedFabric = fabricAttr.values?.find(
            (fabric) => fabric?.assetId === selectedFabricAssetId
          );
          console.log({ selectedFabric });
          fabric = selectedFabric;
        }

        const productPrice = Number(product.productPrice?.toFixed(2));
        const dealerPrice = Number(product.dealerPrice?.toFixed(2));
        const decorationsPrice = Number(rootState.threekit.decorationsPrice);
        const decorationsMsrp = Number(decorationsPrice / 2);
        const finalPrice = (
          Number(productPrice) + Number(decorationsPrice)
        )?.toFixed(2);
        const finalMsrp = Number(dealerPrice + decorationsMsrp)?.toFixed(2);

        console.log({
          productPrice,
          dealerPrice,
          decorationsPrice,
          decorationsMsrp,
          finalPrice,
          finalMsrp,
        });

        let params = {
          alias: product.alias || product.styleId || product.style_id,
          dealer_id: rootState.dealer.id,
          //Todo, ver de donde sacamos los colores de los sublimables
          //Temporalmente mandamos los colores del playbook, porque no hay ediciones individuales
          colors: getters.isPlaybook
            ? [...getters.projectColors.map((c) => c.color?.id)]
            : [product.variant],
          colorsNames: getters.isPlaybook
            ? [...getters.projectColors.map((c) => c.color?.family_name.trim())]
            : [product.variant],
          design: heroDesign || design,
          fabric,
          gender: product.genders ? product.genders[0] : product.gender,
          isSublimable: !!product.isSublimable || !!product.is_sublimable,
          layout: product.activeLayoutId || layout,
          locker_code: lockerCode,
          name: product.name,
          product_id: product.id,
          dealerPrice,
          decorationsPrice,
          decorationsMsrp,
          productPrice,
          productMsrp: dealerPrice,
          finalMsrp,
          finalPrice,
          price: finalPrice,
          styleId: product.styleId,
          variant:
            product.variant ||
            product.variant?.color_name?.trim() ||
            product.variants?.[0]?.color_name?.trim(),
          //Threekit stuff
          brand: product.brand,
          short_id: shortId,
          configId: builderConfig?.configId,
          snapshots: builderConfig.productSnapshots,
          // short_id: shortId,
          design_name: rootGetters[
            "threekit/activeDesignAttribute"
          ]?.values?.find(
            (d) =>
              d.assetId ===
              rootGetters["threekit/activeDesignAttribute"]?.value?.assetId
          )?.name,
          production_time: product.production_time,
          style_name: product.styleName,
          style_id: product.styleId || product.style_id,
          threekit_decorations: rootState.threekit.decorations3DList,
          //The product is being edited
          locker_product_id: product.lockerProductId,
        };
        console.log({
          "builderConfig.decorationsSnapshots":
            builderConfig?.decorationsSnapshots,
        });
        //Map Decorations
        const threekitDecorations = rootState.threekit.decorations3DList?.map(
          (decoration) => {
            //Find decoration inside builderConfig
            const builderDecoration = builderConfig?.decorationsSnapshots?.find(
              (builderDeco) => {
                console.log({ builderDeco, decoration });
                return (
                  builderDeco?.reversibleView?.toLowerCase() ===
                    decoration?.reversibleView?.toLowerCase() &&
                  builderDeco?.locationName.toLowerCase() ===
                    decoration?.locationName.toLowerCase()
                );
              }
            );
            return {
              ...decoration,
              thumbnail: builderDecoration?.url,
            };
          }
        );

        //Add more fields required for playmaker
        for (let decorationIndex = 0; decorationIndex < threekitDecorations.length; decorationIndex++) {
          const threekitDecorationItem = threekitDecorations[decorationIndex];

          if (threekitDecorationItem.configuration.Logo != null) {
            threekitDecorationItem.configuration.Logo["graphicNotes"] = "Gameplan order"
            threekitDecorationItem.configuration.Logo["editDisplayAttributeLayers"] = []
            threekitDecorationItem.configuration.Logo["graphicUrl"] = threekitDecorationItem.configuration.Logo.url
            threekitDecorationItem.configuration.Logo["isFlipped"] = !!threekitDecorationItem.configuration.Rotation

            if (threekitDecorationItem.configuration.Rotation != null) {
              threekitDecorationItem.configuration.Logo["isFlippedRotationAngle"] = threekitDecorationItem.configuration.Rotation
            }

            //Uploads
            if (threekitDecorationItem.configuration["Content Type"] === "Uploads") {
              threekitDecorationItem.configuration.Logo["isFsgGraphic"] = false
              threekitDecorationItem.configuration.Logo["originalGraphicUrl"] = 'N/A'
            }
            //Graphics
            else {
              threekitDecorationItem.configuration.Logo["isFsgGraphic"] = true
              threekitDecorationItem.configuration.Logo["originalGraphicUrl"] = 'N/A'
              threekitDecorationItem.configuration.Logo["graphicLayers"] = []
              threekitDecorationItem.configuration.Logo["storedGraphics"] = []
            }
          }

        }

        console.log({ threekitDecorations });
        params["threekit_decorations"] = threekitDecorations;

        //Related prices (Snapsheets and Playbooks)
        if (product.relatedPricesFromProject) {
          params["relatedPricesFromProject"] = product.relatedPricesFromProject;
        }

        //For Design Products, add the Design name
        if (params.isSublimable && product.design && product.design.name) {
          params["name"] = params["name"] + ", " + product.design?.name;
        }

        if (!lockerCode) {
          params["project_id"] = getters.projectId;
          params["project_type"] = state.typeOfProject;
        }

        //Precolored options
        if (isPrecolored) {
          params["origin"] = "playbook";

          //Flag to indicate if the product is precolored. The Image proof will be just one image
          params["is_precolored"] = true;
          const precolored_design_url_1 = getters.getPrecoloredDesignURL(
            rootGetters["playbook/color1"],
            "c1",
            precoloredDesign,
            isChromagear
          );

          const precolored_design_url_2 = getters.getPrecoloredDesignURL(
            rootGetters["playbook/color2"],
            "c2",
            precoloredDesign,
            isChromagear
          );

          const precolored_design_url_3 = getters.getPrecoloredDesignURL(
            rootGetters["playbook/color3"],
            "c3",
            precoloredDesign,
            isChromagear
          );

          const precolored_shadow =
            getters.getPrecoloredShadowURL(precoloredShadow);

          params["design"] = {
            ...params["design"],
            precolored_design_url_1,
            precolored_design_url_2,
            precolored_design_url_3,
            precolored_shadow,
            precolored_dimension: designDimension,
          };
        }

        //Save the active product colors

        //Principal Color - Stock or Design
        //Change the view to the inside so we can get the principal color
        await dispatch("threekit/changeReversibleView", "Outside", {
          root: true,
        });

        params["product_colors"] =
          rootGetters["threekit/activeProductPrincipalColors"];

        //3D Reversible
        if (rootGetters["threekit/isReversible3D"]) {
          //Change the view to the inside so we can get the principal color
          await dispatch("threekit/changeReversibleView", "Inside", {
            root: true,
          });

          params["product_colors_reversible"] =
            rootGetters["threekit/activeProductPrincipalColors"];

          //Reset reversible views
          await dispatch("threekit/changeReversibleView", "Outside", {
            root: true,
          });
        }

        params["test"] = "test"

        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        dispatch("lockerModule/setLoadingLockerState", true, { root: true });
        //Create a new locker product or update an existing one
        const { data } = isNewLockerProduct
          ? await axios.post(url, params, settings)
          : await axios.put(url, params, settings);

        const newLockerCode = isNewLockerProduct
          ? data
          : rootGetters["lockerModule/lockerCode"];

        await dispatch("setProjectLockerCode", newLockerCode);

        await dispatch("lockerModule/getLockerByCode", newLockerCode, {
          root: true,
        });

        return params;
      } catch (error) {
        dispatch(
          "showToast",
          {
            txt: "An error has occurred",
            type: "error",
          },
          { root: true }
        );
        console.log(error);
        throw new Error();
      } finally {
        dispatch("lockerModule/setLoadingLockerState", false, { root: true });
      }
    },

    async createBuilderSizesOrRosterDefaultData(
      { rootState, state, dispatch },
      { isRoster }
    ) {
      const products = [];
      const threekitDecorations = rootState.threekit.decorations3DList;

      const hasPlayerNameDecoration = threekitDecorations?.some(
        (decoration) =>
          decoration?.configuration?.["Content Type"] === "Player Name"
      );
      const hasPlayerNumberDecoration = threekitDecorations?.some(
        (decoration) =>
          decoration?.configuration?.["Content Type"] === "Player Number"
      );

      //Get the original product data
      const productData = await dispatch(
        "getProductByStyleId",
        state.activeProduct?.style_id || state.activeProduct?.style_name
      );
      console.log({ productData });
      const sizesOrder = [
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "2XL",
        "3XL",
        "4XL",
        "5XL",
        "6XL",
      ];

      if (productData) {
        const sizes = await dispatch(
          "getProductSizesPrice",
          productData?.style_id
        );
        let orderedSizes = [];

        sizes.forEach((sizeItem) => {
          const index = sizesOrder.findIndex((orderedSize) => {
            return orderedSize === sizeItem.size;
          });

          orderedSizes[index] = sizeItem.size;
        });

        orderedSizes = orderedSizes.filter((s) => s);

        const originalProduct = {
          alias: productData.alias,
          gender: productData.gender,
          styleId: productData?.style_id,
          sizes: orderedSizes?.map((size) => {
            const basePrice = Number(
              sizes.find((sizeItem) => {
                return sizeItem?.size === "L";
              })?.price
            );
            const sizePrice = Number(
              sizes.find((sizeItem) => sizeItem?.size === size)?.price
            );
            const upcharge = sizePrice - basePrice;
            const data = {
              size: size,
              price: Number(state.activeProduct.productPrice) + upcharge,
              quantity: size === "L" ? 1 : 0,
            };

            if (isRoster && size === "L") {
              if (hasPlayerNameDecoration) {
                data["playerNameValue"] = "Player Name";
              }

              if (hasPlayerNumberDecoration) {
                data["playerNumberValue"] = "00";
              }
            }

            return data;
          }),
          selected: true,
          disabled: true,
        };

        products.push(originalProduct);

        // Get the related products data
        const relatedProducts = productData.related_data?.filter(
          (r) => r?.style_id !== originalProduct.styleId
        );

        if (relatedProducts && relatedProducts.length > 0) {
          for (const related of relatedProducts) {
            const relatedProductData = await dispatch(
              "getProductByStyleId",
              related.style_id
            );
            if (relatedProductData) {
              const sizes = await dispatch(
                "getProductSizesPrice",
                relatedProductData?.style_id
              );

              let orderedSizes = [];

              sizes.forEach((sizeItem) => {
                const index = sizesOrder.findIndex((orderedSize) => {
                  return orderedSize === sizeItem.size;
                });

                orderedSizes[index] = sizeItem.size;
              });

              orderedSizes = orderedSizes.filter((s) => s);

              const product = {
                alias: relatedProductData?.alias,
                gender: relatedProductData?.gender,
                styleId: relatedProductData?.style_id,

                sizes: orderedSizes?.map((size) => {
                  const basePrice = Number(
                    sizes.find((sizeItem) => {
                      return sizeItem?.size === "M";
                    })?.price
                  );
                  const sizePrice = Number(
                    sizes.find((sizeItem) => sizeItem?.size === size)?.price
                  );
                  const upcharge = sizePrice - basePrice;
                  return {
                    size: size,
                    price: Number(state.activeProduct.productPrice) + upcharge,
                    quantity: 0,
                  };
                }),
                selected: false,
              };
              products.push(product);
            }
          }
        }
        console.log("PRODUCTS DEFAULT DATA: ", products);
        return products;
      }
    },

    async createBuilderConfigsForQuoteProducts({ rootState, dispatch }) {
      try {
        console.log({
          "rootState.lockerModule": rootState.lockerModule.locker.products,
        });
        const products = rootState.lockerModule.locker.products;

        for await (const product of products) {
          const newConfigId = await dispatch("saveProductInBuilder", {
            product,
            shortId: product.short_id || product.shortId,
          })?.configId;
          await dispatch("updateLockerProductConfigId", {
            lockerProductId: product.lockerProductId,
            params: { config_id: newConfigId },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateLockerProductConfigId(
      { rootState },
      { lockerProductId, params }
    ) {
      console.log({ params });
      try {
        const url =
          rootState.settings.endpoint +
          `api/v2/lockers/item/${lockerProductId}/configId`;
        let settings = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + rootState.auth.apiToken,
          },
        };

        await axios.put(url, params, settings);
      } catch (error) {
        console.log(error);
      }
    },

    async saveProductInBuilder(
      { dispatch, rootState, rootGetters },
      { product, shortId }
    ) {
      console.log({ saveProductInBuilderProduct: product });
      try {
        const url = `${process.env.VUE_APP_BUILDER_ENDPOINT}/saved-configs`;
        const bodyFormData = new FormData();

        //Init Threekit required data
        await dispatch(
          "threekit/initProductCache",
          { styleName: product.style_id, designName: product?.design_name },
          { root: true }
        );
        await dispatch("threekit/initThreekitColors", null, { root: true });
        await dispatch("threekit/getThreekitFonts", null, { root: true });

        //Get Threekit saved data
        const threekitData = await dispatch(
          "threekit/getSavedProductConfiguration",
          shortId,
          { root: true }
        );

        const b64toBlob = (dataURI) => {
          var byteString = atob(dataURI.split(",")[1]);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);
          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          return new Blob([ab], { type: "image/png" });
        };

        //Threekit Product Snapshots
        const snapshots = await dispatch(
          "threekit/getImageProofSnapshots",
          null,
          { root: true }
        );

        //Snapshots Objects
        const productPreviews = Object.keys(snapshots).map((key) => {
          return {
            data: b64toBlob(snapshots[key]),
            view: key.includes("reversible")
              ? key.replace("_reversible", "")
              : key,
            productView: key.includes("reversible") ? "Inside" : "Outside",
          };
        });

        //Append BLOBs directly to formData
        Object.keys(snapshots).map((key) => {
          const side = key.includes("reversible")
            ? key.replace("_reversible", "")
            : key;

          const view = key.includes("reversible") ? "Inside" : "Outside";

          console.log('snaps', `${side} ${view}`, b64toBlob(snapshots[key]))

          bodyFormData.append(`${side} ${view}`, b64toBlob(snapshots[key]));
        });

        //Map Decorations info
        const outsideLocations = [];
        const insideLocations = [];

        const outsideDecorationsList =
          rootState.threekit.decorations3DList?.filter(
            (decoration) => decoration.reversibleView === "Outside"
          );
        const insideDecorationsList =
          rootState.threekit.decorations3DList?.filter(
            (decoration) => decoration.reversibleView === "Inside"
          );

        const mapDecorations = async (decorationsList, decorationsToSend) => {
          for await (const decoration of decorationsList) {
            const { configuration } = decoration;
            console.log({ "configuration for": configuration });
            const textOutline1 = configuration["Text Outline 1"]
              ? rootGetters["threekit/findThreekitColorByAssetId"](
                  configuration["Text Outline 1"].assetId
                )
              : null;
            const textOutline2 = configuration["Text Outline 2"]
              ? rootGetters["threekit/findThreekitColorByAssetId"](
                  configuration["Text Outline 2"].assetId
                )
              : null;
            const textFill = configuration["Text Fill"]
              ? rootGetters["threekit/findThreekitColorByAssetId"](
                  configuration["Text Fill"].assetId
                )
              : null;

            const decorationToSend = {
              view: configuration.view,
              nudge: 0,
              effect: "Straight",
              height: configuration["Text Height"],
              location: decoration.locationName,
              textFont: rootGetters["threekit/getFontByAssetId"](
                configuration["Font"]?.assetId
              )?.name,
              textType: configuration["Decoration Material"],
              textInput: configuration["Text"],
              contentType: configuration["Content Type"],
              // uploadedURL:
              //   "https://3d.dev.builder.foundersport.com/data/configs/2022/09/UH/JG/UW/pv-Front-Outside-Upper Front-2022-09-14T14:01:36.401Z.png",
              // heightAdjust: [
              //   {
              //     gender: "J5JV1Y",
              //     height: '9"',
              //   },
              // ],
              isValidTextForm: true,
              // heightConflict: true,
              locationView: decoration.reversibleView,
              textOutline1: textOutline1?.name || "NONE",
              textOutline2: textOutline2?.name || "NONE",
              savedDecoration: true,
              textOutline1Hex: textOutline1?.hex?.substring(1) || null,
              textOutline2Hex: textOutline2?.hex?.substring(1) || null,
              textFillColor: textFill?.name,
              textFillColorHexCode: textFill?.hex?.substring(1),
              textFillColorShortCode:
                textFill?.metadata?.["Color Shortcode"] || null,
              locationShortCode: configuration["Location Shortcode"],
              textRotation: 0,
            };

            //Save Graphics URLs
            decorationToSend["editDisplayAttributeLayers"] = [];
            decorationToSend["isFlipped"] = false /////////

            if (configuration["Content Type"] === "Uploads") {
              decorationToSend["graphicId"] = configuration["Logo"] ? configuration["Logo"]["asset_id"] ? configuration["Logo"]["asset_id"] : configuration["Logo"]["assetId"] : null;
              decorationToSend["graphicUrl"] = configuration["Logo"]["url"];
              decorationToSend["originalGraphicUrl"] = configuration["Logo"]["original_url"];
              decorationToSend["originalGraphicName"] = configuration["Logo"]["name"] ? configuration["Logo"]["name"] : configuration["Logo"]["url"] ? configuration["Logo"]["url"].split('/').pop() : configuration["Logo"]["original_url"];
                decorationToSend["graphicNotes"] = "Gameplan order";
                decorationToSend["isFsgGraphic"] = false;
            }

            else {
              decorationToSend["graphicId"] = configuration["Logo"] ? configuration["Logo"]["asset_id"] ? configuration["Logo"]["asset_id"] : configuration["Logo"]["assetId"] : null;
              decorationToSend["graphicLayers"] = [];
              decorationToSend["storedGraphics"] = [];
              decorationToSend["isFsgGraphic"] = true;

              decorationToSend["graphicLayers"] = null /////
              decorationToSend["decorationImageURL"] = configuration["Logo"] ? configuration["Logo"]["url"] : null; /////
              decorationToSend["decorationImageBlob"] = {}; /////
            }


            decorationsToSend.push(decorationToSend);
          }
        };

        await mapDecorations(outsideDecorationsList, outsideLocations);
        await mapDecorations(insideDecorationsList, insideLocations);

        //Map Decorations Snapshots

        const decorationsPreviews = rootState.threekit.decorations3DList?.map(
          (decoration) => {
            const blob = decoration?.thumbnail
              ? b64toBlob(decoration?.thumbnail)
              : {};

            return {
              view: decoration?.configuration?.view,
              productView: decoration?.reversibleView,
              location: decoration?.locationName,
              data: blob,
              pattern: false,
            };
          }
        );

        //Append Decorations's Blobs directly to Form Data
        decorationsPreviews.forEach((decoration) => {
          bodyFormData.append(
            decoration.view +
              " " +
              decoration.productView +
              decoration.location,

            decoration.data
          );
        });

        //Map Colors
        const colorsConfig = [];
        const insideColorsConfig = [];

        const getColor = (colorKey, layerKey, designKey, colorsToPush) => {
          const colorAssetId =
            threekitData.variant[designKey].configuration[colorKey]?.assetId ||
            threekitData.variant[designKey].configuration[layerKey]
              ?.configuration?.["Fill"]?.assetId;
          const color =
            rootGetters["threekit/findThreekitColorByAssetId"](colorAssetId);
          const colorData = {
            hex: color.hex,
            key: layerKey || colorKey,
            code: color.metadata["Color Shortcode"],
            name: color.name,
            layerName: `Layer - ${colorKey}`,
          };

          //Layer additional data
          if (layerKey) {
            colorData["colorRelation"] = {
              Type: "Layer",
              Order: layerKey.substr(layerKey.length - 1),
              Style: product.style_id,
              Design: product.designName,
              Format: "Vector",
              "Layer Name": colorKey,
              "Color Group": layerKey.substr(layerKey.length - 1),
            };
          }
          colorsToPush.push(colorData);
        };

        const mapColors = (designKey, stockKey, colorsToPush) => {
          //Sublimation colors
          if (threekitData.variant[designKey]) {
            //Map Colors
            Object.keys(threekitData.variant[designKey].configuration).forEach(
              (key) => {
                if (
                  key === "Color 1" ||
                  key === "Color 2" ||
                  key === "Color 3"
                ) {
                  getColor(key, null, designKey, colorsToPush);
                }
              }
            );
            // Map Layers
            Object.keys(threekitData.variant[designKey].configuration).forEach(
              (key) => {
                if (key.includes("Layer")) {
                  const colorKeyIndex = key.indexOf("Color");
                  const colorKey = key.substring(colorKeyIndex);

                  getColor(colorKey, key, designKey, colorsToPush);
                }
              }
            );
          } else if (threekitData.variant[stockKey]) {
            //Stock Colors
            const colorAssetId = threekitData.variant[stockKey].assetId;
            const stockColor = rootGetters[
              "threekit/findStockColorOnStockProductByAssetId"
            ]({
              styleName: product.style_id,
              assetId: colorAssetId,
            });
            const completeStockColor = rootGetters[
              "threekit/findThreekitColorByName"
            ](stockColor.name, "stockColors");
            const colorData = {
              code: completeStockColor.metadata["Color Shortcode"],
              name: completeStockColor.name,
            };

            colorsToPush.push(colorData);
          }
        };
        mapColors("Design", "Color", colorsConfig);
        mapColors("Design (Reverse)", "Color (Reverse)", insideColorsConfig);

        const builderData = {
          name: "Gameplan test",
          braid: {},
          brand: product.brand,
          color: colorsConfig,
          insideColor: insideColorsConfig,
          recentColors: { recentColorsList: [] },
          design: product.design,
          fabric: product.fabric,
          source: "gameplan",
          stitch: {
            customStitching: false,
          }, // ???
          groupId: null, /// ??? null
          rosters: [
            {
              items: [],
            },
          ],
          sizePrice: [],
          finalSizePrice: [],
          configId: "",
          assets: [...outsideLocations, ...insideLocations],
          Locations: outsideLocations,
          colorMode: "Layer",
          builderSKU: product.sku, /// ??? alias/Style Id?
          decoration: [],
          cameraViews: [
            "Default",
            "Front",
            "Back",
            "Left",
            "Right",
            "PDF_Front",
            "PDF_Back",
          ],
          currentView: "Outside",
          defaultFont: "FULL BLOCK",
          isGroupItem: false, // ??? if we have a roster, and there is more than one gender
          productName: product.name,
          defaultGender: product.gender,

          isAddedToCart: false,
          isSavedDesign: true, // ??? karunakar will review it

          isMasterDesign: false,
          isPlayerRoster: false, // ??? based on the roster
          previewsLoaded: false, // ??? based on previews, todo
          insideLocations: insideLocations, // ??? based on reversible product
          previewsLoading: false,
          primaryConfigId: false,
          addingCustomBraid: "", // ??? karunakar will review it

          // generatedPreviews: [
          //   {
          //     url: "https://3d.dev.builder.foundersport.com/data/configs/2022/09/BK/MZ/DH/pv-PDF_Back-Outside-2022-09-14T18:41:20.898Z.png",
          //     view: "PDF_Back",
          //     productView: "Outside",
          //   },
          //   {
          //     url: "https://3d.dev.builder.foundersport.com/data/configs/2022/09/BK/MZ/DH/pv-PDF_Front-Outside-2022-09-14T18:41:20.897Z.png",
          //     view: "PDF_Front",
          //     productView: "Outside",
          //   },
          //   {
          //     url: "https://3d.dev.builder.foundersport.com/data/configs/2022/09/BK/MZ/DH/pv-Default-Outside-2022-09-14T18:41:20.891Z.png",
          //     view: "Default",
          //     productView: "Outside",
          //   },
          //   {
          //     url: "https://3d.dev.builder.foundersport.com/data/configs/2022/09/BK/MZ/DH/pv-Right-Outside-2022-09-14T18:41:20.896Z.png",
          //     view: "Right",
          //     productView: "Outside",
          //   },
          //   {
          //     url: "https://3d.dev.builder.foundersport.com/data/configs/2022/09/BK/MZ/DH/pv-Back-Outside-2022-09-14T18:41:20.894Z.png",
          //     view: "Back",
          //     productView: "Outside",
          //   },
          //   {
          //     url: "https://3d.dev.builder.foundersport.com/data/configs/2022/09/BK/MZ/DH/pv-Left-Outside-2022-09-14T18:41:20.895Z.png",
          //     view: "Left",
          //     productView: "Outside",
          //   },
          //   {
          //     url: "https://3d.dev.builder.foundersport.com/data/configs/2022/09/BK/MZ/DH/pv-Front-Outside-2022-09-14T18:41:20.893Z.png",
          //     view: "Front",
          //     productView: "Outside",
          //   },
          // ],
          initiateConfigProcess: true,
          relatedOrders: [], // ???f
        };

        bodyFormData.append("styleNum", product.style_id); //J5JC1A
        bodyFormData.append("webUserId", 60); //60
        bodyFormData.append("corpAcctId", 123456); //123456
        bodyFormData.append("configId", null);
        bodyFormData.append("assets", [
          ...outsideLocations,
          ...insideLocations,
        ]);
        bodyFormData.append("name", "Gameplan test"); //My Saved Design
        bodyFormData.append("data", JSON.stringify(builderData));
        bodyFormData.append("threeKitMeta", JSON.stringify(threekitData)); //Threekit configurations API response
        bodyFormData.append("isSavedDesign", false); //true
        bodyFormData.append("isAddedToCart", false); //false
        bodyFormData.append("isMasterConfig", false); //false
        bodyFormData.append("previews", JSON.stringify(productPreviews)); //Snapshots of all views (Front, left, right, back)
        bodyFormData.append(
          "locationPreviews",
          JSON.stringify(decorationsPreviews)
        ); //Decoration snapshots
        bodyFormData.append("layerPatterns", JSON.stringify([]));
        bodyFormData.append("isGroupItem", false); //false
        bodyFormData.append("isPrimaryConfigId", null);
        bodyFormData.append("groupId", null);
        bodyFormData.append("source", "gameplan"); //Gameplan
        bodyFormData.append("brand", product.brand); //Badger, Alleson, Chromagear

        const { data } = await axios.post(url, bodyFormData);
        const response = data[0];

        //Order Snapshots
        let ordererSnapshots = [];

        CONSTANTS.VIEWS_3D.forEach((viewKey) => {
          const snapshoToSave = response.previews.find(
            (snapshot) =>
              snapshot?.productView === "Outside" && snapshot?.view === viewKey
          );

          snapshoToSave && ordererSnapshots.push(snapshoToSave);
        });

        CONSTANTS.VIEWS_3D.forEach((viewKey) => {
          const snapshoToSave = response.previews.find(
            (snapshot) =>
              snapshot?.productView === "Inside" && snapshot?.view === viewKey
          );

          snapshoToSave && ordererSnapshots.push(snapshoToSave);
        });

        return {
          productSnapshots: ordererSnapshots,
          configId: response.configId,
          decorationsSnapshots: [
            ...response.data["Locations"],
            ...response.data["insideLocations"],
          ]?.map((decoration) => ({
            url: decoration?.uploadedURL,
            locationName: decoration?.location,
            view: decoration?.view,
            reversibleView: decoration?.locationView,
          })),
        };
      
      } catch (error) {
        console.log(error);
      }
    },

    async updateBuilderRosterOrSizes({ dispatch }, product) {
      console.log("updateBuilderRosterOrSizes prodict", product);
      try {
        //Roster - Sizes Selection
        let sizesSelection = null;
        let rosterSelection = null;
        if (product.sizes_selection || product.roster) {
          //Get SKUS, and filter them by Size+Color
          // const skus = await dispatch("getProductPricing", {
          //   styleId: product.alias,
          //   designName: product.design_name,
          // });

          // //For sublimated colors, just get all of the skus. For Stock, filter by color
          // const filteredSkusByColor =
          //   product.product_colors?.length === 3
          //     ? skus
          //     : skus.filter(
          //         (sku) => sku.colorCode === product.product_colors[0]
          //       );

          if (product.sizes_selection) {
            sizesSelection = await dispatch("getBuilderSizes", {
              sizesSelection: product.sizes_selection,
              designName: product.design_name,
              productColors: product.product_colors,
              productPrice: product.productPrice,
            });
          } else if (product.roster) {
            rosterSelection = await dispatch("getBuilderRoster", {
              rosterItems: product.roster,
              designName: product.design_name,
              productColors: product.product_colors,
              productPrice: product.productPrice,
            });
          }
          const putURL = `${process.env.VUE_APP_BUILDER_ENDPOINT}/saved-configs/${product.configId}`;
          const getURL = `${process.env.VUE_APP_BUILDER_ENDPOINT}/configs/${product.configId}`;

          const config = await axios.get(getURL);
          const builderData = {
            ...config?.data[0].data,
          };
          //Append Roster/Sizes data
          if (rosterSelection) {
            builderData["sizePrice"] = rosterSelection;
          }
          if (sizesSelection) {
            console.log({ sizesSelection });
            builderData["finalSizePrice"] = sizesSelection.flat();
          }

          const bodyFormData = new FormData();
          bodyFormData.append("data", JSON.stringify(builderData));

          bodyFormData.append("styleNum", product.style_id); //J5JC1A
          bodyFormData.append("webUserId", 60); //60
          bodyFormData.append("corpAcctId", 123456); //123456
          bodyFormData.append("configId", product.configId);
          bodyFormData.append("assets", config?.data[0]?.assets);
          bodyFormData.append("name", "Gameplan test"); //My Saved Design
          bodyFormData.append(
            "threeKitMeta",
            JSON.stringify(config?.data[0]?.threeKitMeta)
          ); //Threekit configurations API response
          bodyFormData.append("isSavedDesign", false); //true
          bodyFormData.append("isAddedToCart", false); //false
          bodyFormData.append("isMasterConfig", false); //false
          bodyFormData.append(
            "previews",
            JSON.stringify(config?.data[0]?.previews)
          ); //Snapshots of all views (Front, left, right, back)
          // bodyFormData.append(
          //   "locationPreviews",
          //   JSON.stringify()
          // ); //Decoration snapshots
          bodyFormData.append("layerPatterns", JSON.stringify([]));
          bodyFormData.append("isGroupItem", false); //false
          bodyFormData.append("isPrimaryConfigId", null);
          bodyFormData.append("groupId", null);
          bodyFormData.append("source", "gameplan"); //Gameplan
          bodyFormData.append("brand", product.brand); //Badger, Alleson, Chromagear

          console.log({ bodyFormData });
          const { data } = await axios({
            method: "put",
            url: putURL,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
          });
          const response = data[0];
          console.log({ data, response });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getBuilderSizes(
      { dispatch, getters },
      { sizesSelection, productColors, designName }
    ) {
      const builderSizes = [];
      for (const pr of sizesSelection) {
        //Get SKUS, and filter them by Size+Color
        const skus = await dispatch("getProductPricing", {
          styleId: pr.alias,
          designName: designName,
        });

        //For sublimated colors, just get all of the skus. For Stock, filter by color
        const filteredSkusByColor =
          productColors?.length === 3
            ? skus
            : skus.filter((sku) => sku.colorCode === productColors[0]);

        const finalSize = pr.sizes.map((size) => {
          const sizeCode = getters["getSizeSkuCodeBySizeCode"](size?.size);
          //Find the sku that matches
          const matchSku = filteredSkusByColor.find((skuByColor) => {
            const skuByColorCode = skuByColor.sku.slice(-2);

            return skuByColorCode === sizeCode;
          });

          return {
            sku: matchSku?.sku,
            size: size?.size,
            price: size.price,
            title: matchSku?.skuName,
            gender: pr?.gender,
            quantity: size?.quantity,
            styleNum: pr?.styleId,
            genDisplay: true,
          };
        });

        builderSizes.push(finalSize);
      }

      return builderSizes;
    },

    async getBuilderRoster(
      { getters, dispatch },
      { rosterItems, designName, productColors, forceDefault }
    ) {
      const builderRoster = [];

      for (const rosterItem of rosterItems) {
        let isFirstItem = rosterItem?.alias === rosterItems?.[0]?.alias;
        //Get SKUS, and filter them by Size+Color
        const skus = await dispatch("getProductPricing", {
          styleId: rosterItem.alias,
          designName: designName,
        });

        //For sublimated colors, just get all of the skus. For Stock, filter by color
        const filteredSkusByColor =
          productColors?.length === 3
            ? skus
            : skus.filter((sku) => sku.colorCode === productColors);

        const sizeCode = getters["getSizeSkuCodeBySizeCode"](
          rosterItem?.size || "L"
        );
        //Find the sku that matches
        const matchSku = filteredSkusByColor.find((skuByColor) => {
          const skuByColorCode = skuByColor.sku.slice(-2);

          return skuByColorCode === sizeCode;
        });
        console.log({
          skus,
          filteredSkusByColor,
          sizeCode,
          matchSku,
          rosterItem,
        });
        const newRosterItem = {
          sku: matchSku?.sku,
          size: rosterItem?.size,
          price: rosterItem.price,
          title: matchSku?.skuName,
          gender: rosterItem?.gender,
          quantity:
            forceDefault && isFirstItem === 0 ? 1 : rosterItem?.quantity,
          styleNum: rosterItem?.styleId,
          name: rosterItem?.playerNameValue || "",
          number: rosterItem?.numberValue | "",
        };

        if (forceDefault) {
          isFirstItem === 0 && builderRoster.push(newRosterItem);
        } else {
          builderRoster.push(newRosterItem);
        }
      }
      return builderRoster;
    },

    redirectToLocker({ state, commit }) {
      const typeOfProject = state.typeOfProject + "s";
      const { dealer_code, project_id } = router.currentRoute.params;
      let route;
      if (typeOfProject === "showrooms") {
        route = `/${typeOfProject}/${dealer_code}/locker`;
      } else {
        route = `/${typeOfProject}/${dealer_code}/${project_id}/locker`;
      }
      router.push(route);

      state.showLockerPreviewModalOpen && commit("TOGGLE_LOCKER_PREVIEW_MODAL");
    },

    redirectToProjectPage({ rootState, getters, state }) {
      const dealerCode = rootState.dealer.rhino_code;

      if (getters.isShowroom) {
        router.push(`/showrooms/${dealerCode}/catalogue`);
      } else {
        const typeOfProject = state.typeOfProject + "s";
        const projectId = getters.projectId;
        router.push(`/${typeOfProject}/${dealerCode}/${projectId}`);
      }
    },

    redirectToShowroomHome() {
      const { dealer_code } = router.currentRoute.params;
      router.push(`/showrooms/${dealer_code}`);
    },

    async saveActiveProductToProject(
      { state, getters, dispatch },
      playbookItemReferences
    ) {
      const product = state.activeProduct;
      try {
        if (getters.isSnapsheet)
          await dispatch("snapsheet/updateProduct", product, { root: true });

        if (getters.isPlaybook) {
          await dispatch(
            "playbook/updatePlaybookItemDecorations",
            { ...playbookItemReferences, product },
            { root: true }
          );
        }
      } catch (error) {
        console.log(error);
        dispatch(
          "showToast",
          {
            txt: "error saving the new product",
            type: "error",
          },
          { root: true }
        );
      }
    },

    async getProductPricing(
      { rootState },
      { styleId, designName, getDealerPrice }
    ) {
      try {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const aeCorpId = getDealerPrice ? rootState.dealer?.fsg_code : "123456";

        var raw = JSON.stringify({
          aeCorpId,
          styleNum: styleId,
          designName: designName,
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const result = await fetch(
          `${process.env.VUE_APP_BUILDER_ENDPOINT}/price/product-pricing`,
          requestOptions
        );

        const skuData = await JSON.parse(await result.text());
        return skuData;
      } catch (error) {
        console.log(error);
      }
    },

    async getActiveProductPricing(
      { state, getters, rootGetters, dispatch },
      { getDealerPrice }
    ) {
      if (!state.activeProduct?.customProductPrice) {
        try {
          const skus = await dispatch("getProductPricing", {
            styleId: state.activeProduct?.alias,
            getDealerPrice,
          });

          console.log({ skus });

          const productColors =
            rootGetters["threekit/activeProductPrincipalColors"];

          const filteredSkusByColor = skus.filter((sku) => {
            //colorCode === null --> for sublimation products
            return sku.colorCode === "Custom Sub"
              ? true
              : sku.colorCode === productColors[0];
          });

          console.log({ filteredSkusByColor });

          const sizeCode = getters["getSizeSkuCodeBySizeCode"]("M");
          //Find the sku that matches
          const matchSku = filteredSkusByColor.find((skuByColor) => {
            const skuByColorCode = skuByColor.sku.slice(-2);

            return skuByColorCode === sizeCode;
          });

          console.log({ matchSku, getDealerPrice });

          if (matchSku) {
            getDealerPrice
              ? //Update dealer cost (dealer price)
                await dispatch(
                  "updateActiveProductDealerPrice",
                  matchSku?.price
                )
              : //Update product price
                await dispatch("updateActiveProductPrice", matchSku?.price);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    updateActiveProductPrice({ commit }, newPrice) {
      commit("UPDATE_ACTIVE_PRODUCT_PRICE", newPrice);
    },
    updateActiveProductDealerPrice({ commit }, newPrice) {
      commit("UPDATE_ACTIVE_PRODUCT_DEALER_PRICE", newPrice);
    },

    //Temporal Product
    setTemporalProduct({ commit, getters, rootGetters }, { product, order }) {
      const previousProduct = getters.isSnapsheet
        ? rootGetters["snapsheet/getProductByOrder"](order)
        : rootGetters["playbook/getProductByOrder"](order);
      const { logo } = previousProduct;

      const temporalProduct = {
        ...product,
        activeLayoutId: product.layouts && product.layouts?.[0]?.id,
        logo,
        logoId: logo?.id,
        order,
        design: product.variant
          ? product.variants?.filter(
              (variant) => variant.color_name.trim() == product.variant.trim()
            )?.[0]
          : product.variants?.[0],
        sizes: product.sizes,
        price: product.price
          ? Number(product.price).toFixed(2)
          : Number(product.msrp).toFixed(2),
        related: product.related,
        wrapperId:
          product.wrapperId != null ? product.wrapperId : product.wrapper_id,
        variant:
          product.variant?.trim() || product.variants?.[0].color_name.trim(),
      };
      commit("SET_TEMPORAL_PRODUCT", temporalProduct);
    },

    //Hero
    setEditableHero({ commit }, product) {
      if (product) {
        const decorations =
          product?.decorations ||
          cloneDeep(CONSTANTS.PRODUCT_DECORATIONS_STRUCTURE);
        product.decorations = decorations;
        commit("SET_EDITABLE_HERO", cloneDeep(product));
      }
    },

    removeTemporalProduct({ commit }) {
      commit("SET_TEMPORAL_PRODUCT", {});
    },

    setDesignsModalProduct({ commit }, product) {
      commit("SET_DESIGNS_MODAL_PRODUCT", product);
    },

    //School

    async createSchoolInQueue({ rootState, state, getters, dispatch }) {
      const url = `${process.env.VUE_APP_GAMEPLAN_SCHOOLS_BACKEND_URL}/school-queue/create`;

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      let params = {
        name: getters.projectTitle,
        mascot: rootState.playbook.teamName,
        city: state.temporaryNewSchool.city,
        state: state.temporaryNewSchool.state,
        project_id: getters.projectId,
        project_type: state.typeOfProject,
        color_1: getters["projectColors"][0].color.name,
        color_2: getters["projectColors"][1].color.name,
        color_3: getters["projectColors"][2].color.name,
        //todo graphic
      };

      await axios.post(url, params, settings);

      //Clear the temporary school
      await dispatch("clearTemporaryNewSchool");
    },

    async createTeamTravelInQueue({ rootState, state, getters, dispatch }) {
      const url = `${process.env.VUE_APP_GAMEPLAN_SCHOOLS_BACKEND_URL}/teams-travel-queue/create`;

      let settings = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + rootState.auth.apiToken,
        },
      };

      let params = {
        name: getters.projectTitle,
        city: "-",
        state: "-",
        mascot: rootState.playbook.teamName,
        project_id: getters.projectId,
        project_type: state.typeOfProject,
        color_1: getters["projectColors"][0].color.name,
        color_2: getters["projectColors"][1].color.name,
        color_3: getters["projectColors"][2].color.name,
        rep_id: getters.projectRep?.id,
        dealer_id: rootState.dealer.id,

        //todo graphic
      };

      const sports = getters.isPlaybook
        ? rootState.catalog.projectCatalogs
        : rootState.snapsheet.snapsheetCollections;

      const sportsAsString = sports.length
        ? sports.map((sport) => sport.name).join(", ")
        : null;

      if (sportsAsString) {
        params["sports"] = sportsAsString;
      }

      await axios.post(url, params, settings);

      //Clear the temporary school
      await dispatch("clearTemporaryNewSchool");
    },

    setTemporaryNewSchool({ commit }, school) {
      commit("SET_TEMPORARY_NEW_SCHOOL", school);
    },

    clearTemporaryNewSchool({ commit }) {
      commit("CLEAR_TEMPORARY_NEW_SCHOOL");
    },

    //UI
    triggerLoading({ state, commit }) {
      !state.loading && commit("SET_LOADING", true);
    },

    endLoading({ commit }) {
      commit("SET_LOADING", false);
    },

    showSaveIndicator({ state, commit }) {
      if (!state.showSaveIndicator) {
        commit("SET_SHOW_SAVE_INDICATOR", true);

        setTimeout(() => {
          commit("SET_SHOW_SAVE_INDICATOR", false);
        }, 3000);
      }
    },

    triggerPaginationSidebar({ commit }, bool) {
      commit("CHANGE_PAGINATION_SIDEBAR_STATE", bool);
    },

    //PLP 2d decorations

    async init2DDecorationsApi() {
      if (!window.decorationsApi) {
        try {
          const api = await window.threekitPlayer({
            el: document.getElementById("decorations-player"),
            authToken: AUTH_TOKEN,
            assetId: "6e0addb0-6d61-41f8-a5bc-d7a03c22d836",
          });

          window.decorationsApi = api;
          await api.getConfigurator();
          const player = api.enableApi("player");
          const configurator = await player.getConfigurator();

          return configurator;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async init2DDecorationsPlayer({ dispatch }) {
      if (!window.threekitPlayer) {
        console.log("missing threekitPlayer");
        return false;
      }

      // const fillColor = getters.isSnapsheet ? getters.color1 : getters.color2,
      //   outlineColor = getters.isSnapsheet ? getters.color1 : getters.color3,
      //   fillBackupColor = "WHITE",
      //   outlineBackupColor = "BLACK";

      //const colorsPalette = getters.isSublimated3D ? 'sublimation' : 'stock'
      // const colorsPalette = "sublimation";

      dispatch("setUniformDecorationLoading", true);
      dispatch("setSpiritwearDecorationLoading", true);

      try {
        const configurator = await dispatch("init2DDecorationsApi");

        window.decorationsConfigurator = configurator;

        //set PLP and graphic config
        // await configurator.setConfiguration({
        //   Number: "20",
        //   Name: getters["uniformMascot"].toUpperCase(),
        //   "Name Fill": {
        //     assetId: rootGetters[
        //       "threekit/getThreekitColorAssetIdByGameplanId"
        //     ](fillColor, fillBackupColor, colorsPalette),
        //   },
        //   "Name Outline": {
        //     assetId: rootGetters[
        //       "threekit/getThreekitColorAssetIdByGameplanId"
        //     ](outlineColor, outlineBackupColor, colorsPalette),
        //   },
        //   Font: { AssetId: "" },
        //   Graphic: {
        //     assetId: "fcfd8bb5-ea3c-4e13-905e-ad1e592e27e5", //decoration canvas id
        //     configuration: {
        //       "Top Text": "",
        //       "Bottom Text": "",
        //       "Top Font": { assetId: "" },
        //       "Bottom Font": { AassetId: "" },
        //       "Middle Logo": { assetId: "" },
        //       "Top Color": {
        //         assetId: rootGetters[
        //           "threekit/getThreekitColorAssetIdByGameplanId"
        //         ](fillColor, fillBackupColor, colorsPalette),
        //       },
        //       "Top Outline 1": {
        //         assetId: rootGetters[
        //           "threekit/getThreekitColorAssetIdByGameplanId"
        //         ](outlineColor, outlineBackupColor, colorsPalette),
        //       },
        //       "Bottom Color": {
        //         assetId: rootGetters[
        //           "threekit/getThreekitColorAssetIdByGameplanId"
        //         ](fillColor, fillBackupColor, colorsPalette),
        //       },
        //     },
        //   },
        // });

        dispatch("setUniformDecorationLoading", false);
        dispatch("setSpiritwearDecorationLoading", false);
      } catch (error) {
        console.log(error);
      }
    },

    async update2DDecoration(
      { dispatch, commit },
      { configuration, decorationType }
    ) {
      commit("showroom/SET_UNIFORM_DECORATION_LOADING", true, { root: true });
      commit("showroom/SET_SPIRITWEAR_DECORATION_LOADING", true, {
        root: true,
      });

      const player = window.decorationsApi.enableApi("player");
      const configurator = await player.getConfigurator();

      let graphicConfiguration = null;

      window.decorationsConfigurator = configurator;

      if (configurator == null) {
        console.log("config is null");
        await dispatch("initWindowThreekitPlayer");
      }
      try {
        await configurator.setConfiguration(configuration);
      } catch {
        console.log("Player is not ready yet");
        await dispatch("initWindowThreekitPlayer");
      }

      if (decorationType === "Uniform") {
        //Set Name, Number configuration for uniform
        await configurator.setConfiguration(configuration);

        //removing graphic configuration for uniform
        graphicConfiguration = {
          "Top Text": "",
          "Top Color": { assetId: "" },
          "Top Outline 1": { assetId: "" },
          "Middle Logo": { AssetId: "" },
          "Bottom Color": { assetId: "" },
          "Bottom Text": "",
        };
      }

      //else add graphic configuration without name and number for spiritwear
      else {
        graphicConfiguration = configuration;
      }

      //apply the graphic configuration (empty field for uniform, graphic with top and bottom text for spiritwear)
      const attributes = window.decorationsConfigurator.getDisplayAttributes();

      const attributeGraphic = attributes.find((a) => {
        return /*a.type === 'Asset' && */ a.name === "Graphic";
      });

      const graphicConfig =
        window.decorationsConfigurator.getNestedConfigurator(attributeGraphic);

      if (graphicConfig)
        await graphicConfig.setConfiguration(graphicConfiguration);

      commit("showroom/SET_UNIFORM_DECORATION_LOADING", false, { root: true });
      commit("showroom/SET_SPIRITWEAR_DECORATION_LOADING", false, {
        root: true,
      });
    },

    setUniformDecorationLoading({ commit }, bool) {
      commit("SET_UNIFORM_DECORATION_LOADING", bool);
    },

    setSpiritwearDecorationLoading({ commit }, bool) {
      commit("SET_SPIRITWEAR_DECORATION_LOADING", bool);
    },

    setDefaultUniformAndSpiritwearDecorationColors({ getters, commit }) {
      const whiteColor = CONSTANTS.COLORS.find((color) => {
        return color.name === "WHITE";
      });
      const blackColor = CONSTANTS.COLORS.find((color) => {
        return color.name === "BLACK";
      });

      const projectColor2 = getters["projectColors"]?.[1]?.color?.id;
      const projectColor3 = getters["projectColors"]?.[2]?.color?.id;
      commit(
        "SET_UNIFORM_FILL_COLOR",
        projectColor2 || (whiteColor ? whiteColor.id : 25)
      );
      commit(
        "SET_SPIRITWEAR_FILL_COLOR",
        projectColor2 || (whiteColor ? whiteColor.id : 25)
      );

      commit(
        "SET_UNIFORM_OUTLINE_COLOR",
        projectColor3 || (blackColor ? blackColor.id : 23)
      );
      commit(
        "SET_SPIRITWEAR_OUTLINE_COLOR",
        projectColor3 || (blackColor ? whiteColor.id : 23)
      );
    },

    updateDefaultUniformAndSpiritwearDecorationColors({ getters, commit }) {
      const whiteColor = CONSTANTS.COLORS.find((color) => {
        return color.name === "WHITE";
      });
      const blackColor = CONSTANTS.COLORS.find((color) => {
        return color.name === "BLACK";
      });

      const projectColor2 = getters["projectColors"]?.[1]?.color?.id;
      const projectColor3 = getters["projectColors"]?.[2]?.color?.id;
      commit(
        "SET_UNIFORM_FILL_COLOR",
        projectColor2 || (whiteColor ? whiteColor.id : 25)
      );
      commit(
        "SET_SPIRITWEAR_FILL_COLOR",
        projectColor2 || (whiteColor ? whiteColor.id : 25)
      );

      commit(
        "SET_UNIFORM_OUTLINE_COLOR",
        projectColor3 || (blackColor ? blackColor.id : 23)
      );
      commit(
        "SET_SPIRITWEAR_OUTLINE_COLOR",
        projectColor3 || (blackColor ? whiteColor.id : 23)
      );

      commit("SET_SPIRITWEAR_MASCOT", getters.projectTitle);
      commit("SET_SPIRITWEAR_SUBMASCOT", getters.projectTeamName);

      commit("SET_UNIFORM_MASCOT", getters.projectTeamName);
    },

    async updateDecorationsForCustomLayouts(
      { dispatch, commit, rootGetters, getters },
      { configurationName, mascot }
    ) {
      if (!window.decorationsApi) {
        console.log("missing API");
        return false;
      }

      const fillColor = rootGetters["project/uniformFillColor"],
        outlineColor = rootGetters["project/uniformOutlineColor"],
        fillBackupColor = "WHITE",
        outlineBackupColor = "BLACK",
        colorsPalette = "sublimation"; //TODO

      const graphic = rootGetters["uploadLogos/editableLogo"];
      const hasGraphic = graphic != null && graphic.asset_id != null;

      const colorsConfiguration = {
        Name: hasGraphic
          ? ""
          : mascot
          ? mascot.toUpperCase()
          : getters["uniformMascot"]?.toUpperCase(),
        Number: "23",
        "Name Fill": {
          assetId: rootGetters[
            "threekit/getThreekitColorAssetIdByGameplanIdShowroom"
          ](fillColor, fillBackupColor, colorsPalette),
        },
        "Name Outline": {
          assetId: rootGetters[
            "threekit/getThreekitColorAssetIdByGameplanIdShowroom"
          ](outlineColor, outlineBackupColor, colorsPalette),
        },
        "Number Fill": {
          assetId: rootGetters[
            "threekit/getThreekitColorAssetIdByGameplanIdShowroom"
          ](fillColor, fillBackupColor, colorsPalette),
        },
        "Number Outline": {
          assetId: rootGetters[
            "threekit/getThreekitColorAssetIdByGameplanIdShowroom"
          ](outlineColor, outlineBackupColor, colorsPalette),
        },
      };

      if (hasGraphic) {
        colorsConfiguration["Graphic"] = {
          assetId: graphic.asset_id,
        };
      } else {
        colorsConfiguration["Graphic"] = null;
      }

      const configurations = [
        {
          name: "Center Chest Home",
          configuration: {
            ...colorsConfiguration,
            Type: "Spiritwear",
            "Name Height": 0,
            "Graphic Width": 160,
            "Name X Offset": 0,
            "Name Y Offset": 0,
            "Number Height": 0,
            "Graphic Height": 160,
            "Name Max Width": 0,
            "Number X Offset": 0,
            "Number Y Offset": 0,
            "Graphic X Offset": 235,
            "Graphic Y Offset": 240,
            "Number Max Width": 0,
          },
        },
        {
          name: "Baseball Home",
          configuration: {
            ...colorsConfiguration,
            Type: "Uniform",
            "Name Height": 60,
            "Graphic Width": 40,
            "Name X Offset": 240,
            "Name Y Offset": 210,
            "Number Height": 50,
            "Graphic Height": 160,
            "Name Max Width": 160,
            "Number X Offset": 295,
            "Number Y Offset": 275,
            "Graphic X Offset": 240,
            "Graphic Y Offset": 210,
            "Number Max Width": 50,
          },
        },
      ];

      //let found = { Uniform: false, Spiritwear: false };
      //const graphic = getters["spiritwearCustomGraphic"];

      //const player = window.decorationsApi.enableApi("player");
      //const configurator = await player.getConfigurator();

      const configuration = configurations.find((c) => {
        return c.name === configurationName;
      });

      if (configuration) {
        //await dispatch('init2DDecorationsPlayer');
        await dispatch("update2DDecoration", {
          configuration: configuration.configuration,
          decorationType: configuration.configuration.Type,
        });

        const locationDecoration = await dispatch(
          "threekit/getForcedLocationSnapshot",
          {
            configuration: configuration.configuration,
            options: {
              width: 470,
              height: 588,
            },
          },
          { root: true }
        );

        commit("updateCatalogLocationDecoration", {
          locationName: configuration.name,
          locationDecoration,
        });

        //We generate a thumbnail for uniform and spiritwear just once
      } else {
        console.log("cant find ", configurationName);
      }
    },

    async updateDecorationsForProjectProductsLayouts({
      dispatch,
      getters,
      commit,
    }) {
      if (!window.decorationsApi) {
        console.log("missing API");
        return false;
      }

      //Update the fill/outline and team name/mascot for decorations
      await dispatch("updateDefaultUniformAndSpiritwearDecorationColors");

      const catalogLocations = getters["projectProducts"].length
        ? getters["projectProducts"].map((product) => {
            return product.threekit_layout || product?.product?.threekit_layout;
          })
        : [];
      if (!catalogLocations.length) {
        console.log("missing locations for all prods");
        return false;
      }

      const locations = catalogLocations
        .filter((location) => {
          return location != null && location.length && location !== "588R";
        })
        .filter((v, i, a) => a.indexOf(v) == i);

      let found = { Uniform: false, Spiritwear: false };

      for (let index = 0; index < locations.length; index++) {
        const locationName = locations[index];

        //returns whole config, so we can get the field "Type" which tells if location is uniform or spiritwear
        const locationConfiguration = await dispatch(
          "threekit/getConfigurationByLocationName",
          locationName,
          { root: true }
        );
        if (!locationConfiguration) {
          continue;
        }

        //const configuration = await dispatch('threekit/getDecorationConfigurationByLocationType', locationConfiguration.Type, { root: true })
        let configuration;

        configuration = await dispatch(
          "threekit/getUniformDecorationConfiguration",
          locationConfiguration,
          { root: true }
        );

        //updates graphic field from decoration canvas using the configurator for uniform/spiritwear
        if (configuration)
          await dispatch("update2DDecoration", {
            configuration,
            decorationType: locationConfiguration.Type,
          });

        const locationDecoration = await dispatch(
          "threekit/getLocationSnapshot",
          {
            locationName,
            configuration,
            options: {
              width: 470,
              height: 588,
            },
          },
          { root: true }
        );

        commit("updateCatalogLocationDecoration", {
          locationName,
          locationDecoration,
        });

        //We generate a thumbnail for uniform and spiritwear just once
        if (
          locationConfiguration.Type &&
          locationConfiguration.Type.length &&
          !found[locationConfiguration.Type]
        ) {
          if (locationConfiguration.Type === "Uniform") {
            await dispatch(`threekit/getUniformThumbnail`, locationName, {
              root: true,
            });
          } else {
            await dispatch(`threekit/getSpiritwearThumbnail`, null, {
              root: true,
            });
          }
          found[locationConfiguration.Type] = true;
        }
      }
    },
  },

  mutations: {
    setProject: (state, projectData) => {
      state.color_1 = projectData.color_1;
      state.color_2 = projectData.color_2;
      state.color_3 = projectData.color_3;
      state.template = projectData.template;
      state.sports = projectData.sports;
      state.type = projectData.type;
      state.pages = projectData.pages;
      state.projectLogos = projectData.logos;
      state.repId = projectData.rep_id;
      state.projectId = projectData.id;
      state.templateId = projectData.template_id;
    },

    SET_PAGE: (state, page) => {
      state.actualPage = page;
    },

    SET_TYPE_OF_PROJECT: (state, typeOfProject) => {
      state.typeOfProject = typeOfProject;
    },

    SET_PROJECT_MODE: (state, mode) => {
      state.mode = mode;
    },

    SET_EXPORT_PDF: (state, status) => {
      state.exportingToPDF = status;
    },

    SET_PROJECT_REP: (state, rep) => {
      state.rep = rep;
    },

    SET_PROJECT_LOGOS: (state, logos) => {
      state.projectLogos = logos;
    },

    SET_DEFAULT_LOGO: (state, logoId) => {
      state.defaultLogoId = logoId;
    },

    ADD_PROJECT_LOGO: (state, logo) => {
      state.projectLogos.push(logo);
    },

    UPDATE_PROJECT_LOGO: (state, { logoIndex, logo }) => {
      Vue.set(state.projectLogos[logoIndex], logo);
    },

    REMOVE_PROJECT_LOGO: (state, logoIndex) => {
      Vue.delete(state.projectLogos, logoIndex);
    },

    SET_PROJECT_LOGO_TYPE: (state, { logoIndex, typesOfLogo }) => {
      Vue.set(state.projectLogos[logoIndex], "type", typesOfLogo);
    },

    SET_PROJECT_LOCKER_CODE(state, lockerCode) {
      state.lockerCode = lockerCode;
    },

    SET_SPIRITWEAR_LOGO_ID: (state, logoId) => {
      state.spiritwearLogoId = logoId;
    },

    SET_UNIFORMS_LOGO_ID: (state, logoId) => {
      state.uniformsLogoId = logoId;
    },

    SET_ACTIVE_PRODUCT: (state, activeProduct) => {
      state.activeProduct = activeProduct;
    },

    UPDATE_ACTIVE_PRODUCT_PRICE: (state, newPrice) => {
      Vue.set(state.activeProduct, "productPrice", newPrice);
    },

    UPDATE_ACTIVE_PRODUCT_DEALER_PRICE: (state, newPrice) => {
      Vue.set(state.activeProduct, "dealerPrice", newPrice);
    },

    SET_EDITABLE_PRODUCT: (state, activeProduct) => {
      state.editableProduct = activeProduct;
    },

    SET_TEMPORAL_PRODUCT: (state, temporalProduct) => {
      Vue.set(state, "temporalProduct", temporalProduct);
    },

    SET_DESIGNS_MODAL_PRODUCT: (state, product) => {
      state.designsModalProduct = product;
    },

    SET_EDITABLE_HERO: (state, product) => {
      Vue.set(state, "editableHero", product);
    },

    CHANGE_ACTIVE_PRODUCT_VARIANT: (state, variant) => {
      Vue.set(state.activeProduct, "variant", variant);
    },

    SET_ACTIVE_PRODUCT_LAYOUT: (state, layoutId) => {
      Vue.set(state.activeProduct, "activeLayoutId", layoutId);
    },

    APPLY_PRODUCT_DECORATIONS: (
      state,
      {
        TYPE_OF_PRODUCT,
        sideKey = "front",
        decorationPropertyName,
        decorationPropertyValue,
      }
    ) => {
      //TYPE_OF_PRODUCT = 'activeProduct' || 'editableProduct'
      //sideKey -> front/back/side
      //decorationPropertyName -> name/number/logo
      //decorationPropertyValue -> an object with values (ex: logo -> {id, url ,content, etc})
      Vue.set(
        state[TYPE_OF_PRODUCT].decorations[sideKey],
        decorationPropertyName,
        decorationPropertyValue
      );
    },

    SET_GLOBAL_UNIFORMS_DECORATIONS: (
      state,
      { sideKey = "front", decorationPropertyName, decorationPropertyValue }
    ) => {
      //TYPE_OF_PRODUCT = 'activeProduct' || 'editableProduct'
      //sideKey -> front/back/side
      //decorationPropertyName -> name/number/logo
      //decorationPropertyValue -> an object with values (ex: logo -> {id, url ,content, etc})
      Vue.set(
        state.globalUniformDecorations[sideKey],
        decorationPropertyName,
        decorationPropertyValue
      );
    },
    TOGGLE_LOCKER_PREVIEW_MODAL: (state) => {
      state.showLockerPreviewModalOpen = !state.showLockerPreviewModalOpen;
    },

    SET_LOADING: (state, loading) => {
      state.loading = loading;
    },

    SET_SHOW_SAVE_INDICATOR: (state, show) => {
      state.showSaveIndicator = show;
    },

    SET_SCREEN_WIDTH: (state, width) => {
      state.screenWidth = width;
    },

    CHANGE_PAGINATION_SIDEBAR_STATE: (state, bool) => {
      state.paginationActive = bool;
    },

    //2d decorations

    SET_UNIFORM_FILL_COLOR: (state, colorId) => {
      state.uniformDecorationFillColor = colorId;
    },

    SET_UNIFORM_OUTLINE_COLOR: (state, colorId) => {
      state.uniformDecorationOutlineColor = colorId;
    },

    SET_SPIRITWEAR_FILL_COLOR: (state, colorId) => {
      state.spiritwearDecorationFillColor = colorId;
    },

    SET_SPIRITWEAR_OUTLINE_COLOR: (state, colorId) => {
      state.spiritwearDecorationOutlineColor = colorId;
    },

    SET_SPIRITWEAR_MASCOT: (state, mascot) => {
      state.spiritwearMascot = mascot;
    },

    SET_SPIRITWEAR_SUBMASCOT: (state, mascot) => {
      state.spiritwearSubMascot = mascot;
    },

    SET_CENTER_DECORATION: (state, centerDecoration) => {
      state.centerDecoration = centerDecoration;
    },

    SET_UNIFORM_MASCOT: (state, mascot) => {
      state.uniformMascot = mascot;
    },

    SET_SPIRITWEAR_FONT: (state, font) => {
      state.spiritwearFont = font;
    },

    SET_UNIFORM_FONT: (state, font) => {
      state.uniformFont = font;
    },

    SET_UNIFORM_CUSTOM_GRAPHIC: (state, graphic) => {
      state.uniformCustomGraphic = graphic;
    },

    SET_SPIRITWEAR_CUSTOM_GRAPHIC: (state, graphic) => {
      state.spiritwearCustomGraphic = graphic;
    },

    CLEAR_UNIFORM_LOGO: (state) => {
      state.uniformCustomGraphic = null;
    },

    CLEAR_SPIRITWEAR_LOGO: (state) => {
      state.spiritwearCustomGraphic = null;
    },

    //PLP 2d decorations

    SET_UNIFORM_DECORATION_LOADING: (state, bool) => {
      state.customDecorationTextLoading = bool;
    },

    SET_SPIRITWEAR_DECORATION_LOADING: (state, bool) => {
      state.customSpiritwearTextLoading = bool;
    },

    updateCatalogLocationDecoration: (state, payload) => {
      //search if we already have this location
      let location = state.locationDecorations.find((l) => {
        return l.locationName === payload.locationName;
      });

      const data = {
        locationName: payload.locationName,
        value: payload.locationDecoration,
        loading: false,
      };

      if (!location?.locationName) {
        state.locationDecorations = [...state.locationDecorations, data];
      } else {
        //console.log('we already have this location data and we are going to update it with:', data)
        const index = state.locationDecorations.findIndex((l) => {
          return l.locationName === payload.locationName;
        });
        state.locationDecorations[index].value = payload.locationDecoration;
      }
    },

    SET_TEMPORARY_NEW_SCHOOL: (state, school) => {
      state.temporaryNewSchool = school;
    },

    CLEAR_TEMPORARY_NEW_SCHOOL: (state) => {
      state.temporaryNewSchool = {};
    },
  },
};

export default project;
